import { Box, styled } from "@mui/material";

export const NavigationScrollButton = styled(Box)<{ disabled?: boolean }>(({ theme, disabled }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	cursor: disabled ? "default" : "pointer",
	opacity: disabled ? 0.5 : 1,
	width: theme.spacing(3),
}));
